import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { MTOSectionHdrContainerModel } from '../../../../../../models/aggregates/erp/mto/mto-section-hdr-container.model';

@Injectable({
  providedIn: 'root'
})
export class MTOSectionHdrService extends BaseApiTemplateService<MTOSectionHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'sections';
  readonly endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'sections/' + Core2Config.PUBLIC_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'sections';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'sections';
    this.httpClient = http;
  }

  getByCriteriaPublic(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MTOSectionHdrContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
